// List of search indexes (Typesense collections)

export enum searchIndexes {
    // Published opportunities
    TAGS = 'tags',
    JOBS = 'jobs',
    ORGS = 'orgs',
    MENTORS = 'profiles',
    PROJECTS = 'projects',
    SKILLS = 'skills',
    SKILLS_START_DATE_DESC_INDEX = 'skills_start_date_desc',
    SKILLS_START_DATE_ASC_INDEX = 'skills_start_date_asc',
    VOLUNTEERS = 'volunteers',
    COMMUNITY_MEMBERS = 'community_members',
    COMMUNITY_GROUPS = 'community_groups',
    COMMUNITY_SECTIONS = 'community_sections',
    TALENTBASE_MEMBERS = 'talentbase_members',
    JOB_REQUESTS = 'job_requests',
    USERS = 'users',

    // Indices with published and unlisted opportunities
    TAGS_PUBLISHED_UNLISTED = 'tags_published_unlisted',
    JOBS_PUBLISHED_UNLISTED = 'jobs_published_unlisted',
    MENTORS_PUBLISHED_UNLISTED = 'mentors_published_unlisted',
    PROJECTS_PUBLISHED_UNLISTED = 'projects_published_unlisted',
    SKILLS_PUBLISHED_UNLISTED = 'skills_published_unlisted',
    VOLUNTEERS_PUBLISHED_UNLISTED = 'volunteers_published_unlisted',

    SEARCHABLE_PAGES_DATA = 'searchable_pages_data',
    BLOGS = 'blogs',

    MERGED_OPPORTUNITIES = 'merged_opportunities'
}

